import { TOccupation } from '@interlayer/js/app/components/main/Registration/components/fields/OccupationField/types';
import {
    TBuyaPowaData,
    TRegDataAction
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/registration/types';
import { TUpgradeDataAction } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/types';
import { TRetailRegDataAction } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailReg/types';
import { TRetailUpgradeDataAction } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailUpgrade/types';
import { TSlotUpgradeDataAction } from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/components/slotUpgrade/types';
import {
    TAdditionalRetailUpgradeData,
    TAdditionalUpgradeData,
    TErrorRegistration,
    TForgotPinDataAction,
    TRegistrationConfig } from '@interlayer/js/app/store/reducers/Registration/types';

import { actionTypes, ONLINE_REG_BUSINESS_PHASES, STEP_NAMES } from './constants';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const setRegistrationConfig = (config: TRegistrationConfig): Action<actionTypes.SET_CONFIG, TRegistrationConfig> => ({
    type: actionTypes.SET_CONFIG,
    payload: config
});

export const setNextStepIndex = (index: number | null): Action<actionTypes.SET_NEXT_STEP_INDEX, number | null> => ({
    type: actionTypes.SET_NEXT_STEP_INDEX,
    payload: index
});

export const setIsRegistered = (isRegistered: boolean): Action<actionTypes.SET_IS_REGISTERED, boolean> => ({
    type: actionTypes.SET_IS_REGISTERED,
    payload: isRegistered
});

export const setLastFieldName = (lastFieldName: string): Action<actionTypes.SET_LAST_FIELD_NAME, string> => ({
    type: actionTypes.SET_LAST_FIELD_NAME,
    payload: lastFieldName
});

export const setAttemptId = (attemptId: string): Action<actionTypes.SET_ATTEMPT_ID, string> => ({
    type: actionTypes.SET_ATTEMPT_ID,
    payload: attemptId
});

export const setIsDestroyed = (isDestroyed: boolean): Action<actionTypes.SET_IS_DESTROYED, boolean> => ({
    type: actionTypes.SET_IS_DESTROYED,
    payload: isDestroyed
});

export const setIsUpgrade = (isUpgrade: boolean): Action<actionTypes.SET_IS_UPGRADE, boolean> => ({
    type: actionTypes.SET_IS_UPGRADE,
    payload: isUpgrade
});

export const setIsShowClosePopup = (isShow: boolean): Action<actionTypes.SET_IS_SHOW_CLOSE_POPUP, boolean> => ({
    type: actionTypes.SET_IS_SHOW_CLOSE_POPUP,
    payload: isShow
});

export const setRegistrationData = (data: TRegDataAction): Action<actionTypes.SET_REGISTRATION_DATA, TRegDataAction> => ({
    type: actionTypes.SET_REGISTRATION_DATA,
    payload: data
});

export const setRegistrationNameStep = (stepName: STEP_NAMES): Action<actionTypes.SET_REGISTRATION_NAME_STEP, STEP_NAMES> => ({
    type: actionTypes.SET_REGISTRATION_NAME_STEP,
    payload: stepName
});

export const setIsManuallyAddress = (isManuallyAddress: boolean): Action<actionTypes.SET_IS_MANUALLY_ADDRESS, boolean> => ({
    type: actionTypes.SET_IS_MANUALLY_ADDRESS,
    payload: isManuallyAddress
});

export const setShowPopupAlreadyMember = (isShow: boolean): Action<actionTypes.SET_IS_SHOW_POPUP_ALREADY_MEMBER, boolean> => ({
    type: actionTypes.SET_IS_SHOW_POPUP_ALREADY_MEMBER,
    payload: isShow
});

export const setUpgradeData = (data: TUpgradeDataAction): Action<actionTypes.SET_UPGRADE_DATA, TUpgradeDataAction> => ({
    type: actionTypes.SET_UPGRADE_DATA,
    payload: data
});

export const setRetailRegData = (data: TRetailRegDataAction): Action<
    actionTypes.SET_RETAIL_REG_DATA,
    TRetailRegDataAction
> => ({
    type: actionTypes.SET_RETAIL_REG_DATA,
    payload: data
});

export const setRetailUpgradeData = (data: TRetailUpgradeDataAction): Action<
    actionTypes.SET_RETAIL_UPGRADE_DATA,
    TRetailUpgradeDataAction
> => ({
    type: actionTypes.SET_RETAIL_UPGRADE_DATA,
    payload: data
});

export const setAdditionalUpgradeData = (data: Partial<TAdditionalUpgradeData>): Action<
    actionTypes.SET_ADDITIONAL_UPGRADE_DATA,
    Partial<TAdditionalUpgradeData>
> => ({
    type: actionTypes.SET_ADDITIONAL_UPGRADE_DATA,
    payload: data
});

export const setAdditionalRetailUpgradeData = (data: Partial<TAdditionalRetailUpgradeData>): Action<
    actionTypes.SET_ADDITIONAL_RETAIL_UPGRADE_DATA,
    Partial<TAdditionalRetailUpgradeData>
> => ({
    type: actionTypes.SET_ADDITIONAL_RETAIL_UPGRADE_DATA,
    payload: data
});

export const setSlotUpgradeData = (data: TSlotUpgradeDataAction): Action<
    actionTypes.SET_SLOT_UPGRADE_DATA,
    TSlotUpgradeDataAction
> => ({
    type: actionTypes.SET_SLOT_UPGRADE_DATA,
    payload: data
});

export const setForceToChangeEmail = (forceToChangeEmail: boolean): Action<actionTypes.SET_FORCE_TO_CHANGE_EMAIL, boolean> => ({
    type: actionTypes.SET_FORCE_TO_CHANGE_EMAIL,
    payload: forceToChangeEmail
});

export const setIsLoadingSendForm = (isLoadingSendForm: boolean): Action<actionTypes.SET_IS_LOADING_SEND_FORM, boolean> => ({
    type: actionTypes.SET_IS_LOADING_SEND_FORM,
    payload: isLoadingSendForm
});

export const setErrorRegistration = (errorObj: TErrorRegistration): Action<
    actionTypes.SET_ERROR_REGISTRATION,
    TErrorRegistration
> => ({
    type: actionTypes.SET_ERROR_REGISTRATION,
    payload: errorObj
});

export const resetToDefault = (): { type: actionTypes.SET_INITIAL_STATE } => ({
    type: actionTypes.SET_INITIAL_STATE
});

export const resetUpgradeToDefault = (): { type: actionTypes.SET_UPGRADE_INITIAL_STATE } => ({
    type: actionTypes.SET_UPGRADE_INITIAL_STATE
});

export const setForgotPinData = (data: TForgotPinDataAction): Action<
    actionTypes.SET_FORGOT_PIN_DATA,
    TForgotPinDataAction
> => ({
    type: actionTypes.SET_FORGOT_PIN_DATA,
    payload: data
});

export const resetToDefaultForgotPinData = (): { type: actionTypes.RESET_FORGOT_PIN_DATA } => ({
    type: actionTypes.RESET_FORGOT_PIN_DATA
});

export const setIsRegistrationInProcess = (status: boolean): Action<actionTypes.SET_IS_REGISTRATION_IN_PROCESS, boolean> => ({
    type: actionTypes.SET_IS_REGISTRATION_IN_PROCESS,
    payload: status
});

export const setOccupationSuggestions = (data: TOccupation[]): Action<actionTypes.SET_OCCUPATION_SUGGESTIONS, TOccupation[]> => ({
    type: actionTypes.SET_OCCUPATION_SUGGESTIONS,
    payload: data
});

export const setIsShowReCaptcha = (isShowReCaptcha: boolean): Action<actionTypes.SET_IS_SHOW_RECAPTCHA, boolean> => ({
    type: actionTypes.SET_IS_SHOW_RECAPTCHA,
    payload: isShowReCaptcha
});

export const setIsSuccessRetailReg = (isSuccess: boolean): Action<actionTypes.SET_IS_SUCCESS_RETAIL_REG, boolean> => ({
    type: actionTypes.SET_IS_SUCCESS_RETAIL_REG,
    payload: isSuccess
});

export const setRegistrationRetailWrapperType =
    (type: string): Action<actionTypes.SET_REGISTRATION_RETAIL_WRAPPER_TYPE, string> => ({
        type: actionTypes.SET_REGISTRATION_RETAIL_WRAPPER_TYPE,
        payload: type
    });

export const setBuyaPowaData = (data: TBuyaPowaData): Action<actionTypes.SET_BUYAPOWA_DATA, TBuyaPowaData> => ({
    type: actionTypes.SET_BUYAPOWA_DATA,
    payload: data
});

export const setBusinessPhase =
    (businessPhase: ONLINE_REG_BUSINESS_PHASES): Action<actionTypes.SET_BUSINESS_PHASES, ONLINE_REG_BUSINESS_PHASES> => ({
        type: actionTypes.SET_BUSINESS_PHASES,
        payload: businessPhase
    });
